import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const YoutubeCircle24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.youtubeFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm.169 7.5h-.384c-.734.005-3.356.033-4.088.229a1.371 1.371 0 00-.968.968C7 10.55 7 12.332 7 12.332s0 1.781.229 2.635c.126.47.497.842.968.968.763.204 3.575.226 4.17.228h.22c.594-.002 3.406-.024 4.17-.228.47-.126.842-.497.968-.968.207-.773.226-2.304.228-2.59v-.091c-.002-.285-.021-1.817-.228-2.59a1.371 1.371 0 00-.969-.967c-.732-.196-3.353-.224-4.087-.228zM11.5 10.664l2.75 1.625-2.75 1.625v-3.25z"
      fillRule="evenodd"
    />
  </svg>
);

export default YoutubeCircle24;
